"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("../../utils/api");
var toolkit_1 = require("@reduxjs/toolkit");
var getCustomerAccount_1 = __importDefault(require("./queries/getCustomerAccount"));
var getCustomerProfileById_1 = __importDefault(require("./queries/getCustomerProfileById"));
var createCustomerProfile_1 = __importDefault(require("./queries/createCustomerProfile"));
var updateCustomerProfile_1 = __importDefault(require("./queries/updateCustomerProfile"));
var deleteCustomerProfile_1 = __importDefault(require("./queries/deleteCustomerProfile"));
var purchaseTvod_1 = __importDefault(require("./queries/purchaseTvod"));
var purchasePpv_1 = __importDefault(require("./queries/purchasePpv"));
var reversePurchasePpv_1 = __importDefault(require("./queries/reversePurchasePpv"));
var constants_1 = require("./constants");
var config_1 = __importStar(require("../../config"));
var selectors_1 = require("./selectors");
var getUserPurchases_1 = __importDefault(require("./queries/getUserPurchases"));
exports.setDefaultSelectedProfile = function (profile) {
    return toolkit_1.createAction(constants_1.SET_SELECTED_PROFILE)({ profile: profile });
};
exports.setSelectedProfileId = function (id) {
    return toolkit_1.createAction(constants_1.SET_SELECTED_CUSTOMER_PROFILE_ID)({ id: id });
};
exports.setSelectedProfile = function (profile) { return function (dispatch) {
    return [
        dispatch(exports.setDefaultSelectedProfile(profile)),
        dispatch(exports.setSelectedProfileId(profile === null || profile === void 0 ? void 0 : profile.id)),
    ];
}; };
exports.getCustomerAccount = function () {
    return api_1.createApiAction(constants_1.GET_CUSTOMER_ACCOUNT, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: getCustomerAccount_1.default,
        },
        authenticated: true,
        graphQL: true,
    });
};
exports.getCustomerProfileById = function (id) {
    return api_1.createApiAction(constants_1.GET_CUSTOMER_PROFILE_BY_ID, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: getCustomerProfileById_1.default,
            variables: { id: id },
        },
        authenticated: true,
        graphQL: true,
    });
};
// For phase 1 we dont need avatar parameter hence making it optional
exports.createCustomerProfile = function (name, avatar) {
    return api_1.createApiAction(constants_1.CREATE_CUSTOMER_PROFILE, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: createCustomerProfile_1.default,
            variables: { name: name, avatar: avatar },
        },
        authenticated: true,
        graphQL: true,
    });
};
exports.updateCustomerProfile = function (id, name) { return function (dispatch, getState) {
    var _a, _b;
    var profiles = selectors_1.getCustomerProfiles(getState());
    var selectedAvatar = null;
    if (profiles) {
        selectedAvatar = (_b = (_a = (profiles || []).find(function (el) { return el.id === id; })) === null || _a === void 0 ? void 0 : _a.customerProfileAvatar) === null || _b === void 0 ? void 0 : _b.id;
    }
    return dispatch(api_1.createApiAction(constants_1.UPDATE_CUSTOMER_PROFILE, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: updateCustomerProfile_1.default,
            variables: { id: id, name: name, avatar: selectedAvatar },
        },
        authenticated: true,
        graphQL: true,
    }));
}; };
exports.deleteCustomerProfile = function (id) { return function (dispatch, getState) {
    return dispatch(api_1.createApiAction(constants_1.DELETE_CUSTOMER_PROFILE, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: deleteCustomerProfile_1.default,
            variables: { id: id },
        },
        authenticated: true,
        graphQL: true,
        meta: { id: id },
        onSuccess: function (successDispatch) {
            var profiles = selectors_1.getCustomerProfiles(getState());
            var defaultProfile = profiles.find(function (el) { return el.isDefault === true; });
            var selectedProfileID = selectors_1.selectedProfileId(getState());
            if ((defaultProfile === null || defaultProfile === void 0 ? void 0 : defaultProfile.id) && id === selectedProfileID) {
                successDispatch(exports.setSelectedProfileId(defaultProfile.id));
            }
        },
    }));
}; };
var purchaseTvod = function (tvodOfferId, deviceId) {
    return api_1.createApiAction(constants_1.PURCHASE_TVOD, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: purchaseTvod_1.default,
            variables: { tvodOfferId: tvodOfferId, deviceId: deviceId },
        },
        authenticated: true,
        graphQL: true,
    });
};
var purchasePpv = function (ppvOfferId) {
    return api_1.createApiAction(constants_1.PURCHASE_PPV, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: purchasePpv_1.default,
            variables: { ppvOfferId: ppvOfferId },
        },
        authenticated: true,
        graphQL: true,
    });
};
var reversePurchase = function (purchaseId) {
    return api_1.createApiAction(constants_1.REVERSE_PURCHASE_PPV, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: reversePurchasePpv_1.default,
            variables: { purchaseId: purchaseId },
        },
        authenticated: true,
        graphQL: true,
    });
};
exports.setPurchasesNotificationById = function (purchaseEvent) {
    return toolkit_1.createAction(constants_1.SET_PURCHASE_NOTIFICATION_BY_ID)(purchaseEvent);
};
var fetchUserPurchases = function () {
    return api_1.createApiAction(constants_1.FETCH_USER_PURCHASES, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: getUserPurchases_1.default,
        },
        graphQL: true,
        authenticated: true,
    });
};
exports.clearResponses = function () { return toolkit_1.createAction(constants_1.CLEAR_PURCHASE_PPV)({}); };
exports.purchases = {
    purchaseTvod: purchaseTvod,
    purchasePpv: purchasePpv,
    reversePurchase: reversePurchase,
    setPurchasesNotificationById: exports.setPurchasesNotificationById,
    fetchUserPurchases: fetchUserPurchases,
    clearResponses: exports.clearResponses,
};
exports.setTextTrackStyle = function (textTrackStyle) {
    return toolkit_1.createAction(constants_1.SET_TEXT_TRACK_STYLE)(textTrackStyle);
};
exports.setSelectedPlayerSettings = function (profileId, settings) {
    return toolkit_1.createAction(constants_1.SET_PLAYER_SETTINGS)({ profileId: profileId, settings: settings });
};
exports.clearPlayerSettings = function () { return toolkit_1.createAction(constants_1.CLEAR_PLAYER_SETTINGS)({}); };
exports.setCustomerPackages = function (customerPackagesIds) {
    return toolkit_1.createAction(constants_1.SET_CUSTOMER_PACKAGES)(customerPackagesIds);
};
//# sourceMappingURL=actions.js.map